<template>
  <div class="page">
    <div class="container">

      <element-processor @submit="submit" :data="processorData">
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>전화 상담</h3></li>
            <li><element-select v-model="processorData.steps[0].formData.insureName.value" :error="processorData.steps[0].formData.insureName.error" :label="processorData.steps[0].formData.insureName.label" :placeholder="processorData.steps[0].formData.insureName.placeholder" :items="processorData.steps[0].formData.insureName.item"/></li>
            <li><element-textbox v-model="processorData.steps[0].formData.name.value" :error="processorData.steps[0].formData.name.error" :label="processorData.steps[0].formData.name.label" :placeholder="processorData.steps[0].formData.name.placeholder" /></li>
            <li><element-textbox type="tel" v-model="processorData.steps[0].formData.phone.value" :error="processorData.steps[0].formData.phone.error" :label="processorData.steps[0].formData.phone.label" :placeholder="processorData.steps[0].formData.phone.placeholder" /></li>

            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[0].formData.consultDate.value" :error="processorData.steps[0].formData.consultDate.error" :label="processorData.steps[0].formData.consultDate.label" :placeholder="processorData.steps[0].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[0].formData.consultTime.value" :error="processorData.steps[0].formData.consultTime.error" :label="processorData.steps[0].formData.consultTime.label" :placeholder="processorData.steps[0].formData.consultTime.placeholder"
                :date="processorData.steps[0].formData.consultDate.value"/>
            </li>
            <li><element-textarea v-model="processorData.steps[0].formData.consultRemark.value" :error="processorData.steps[0].formData.consultRemark.error" :label="processorData.steps[0].formData.consultRemark.label" :placeholder="processorData.steps[0].formData.consultRemark.placeholder" /></li>
          </ul>

          <div class="checkMyInsurance">
            <el-checkbox v-model="checkmyinsure">
              내 보험 점검 신청하기 <span class="grey-font">(선택)</span>
              <el-popover
                placement="top"
                width="800"
                trigger="click"
              >
                <div>
                  고객님께서 현재 가입한 모든 보험 및 보장금액 내용을 한국신용정보원과 보험협회로 부터 조회하여 이메일 및 카톡으로 보내드립니다.
                  결과 서류를 보시면 불필요한 보험을 정리하거나 리모델링을 종합적으로 판단하고 선택하실 수 있습니다.
                </div>

                <span slot="reference">
                  <!-- <img style="display: inline-block; margin-left: 0.2rem; max-width: 1.2rem; line-height: 3.5rem; vertical-align: middle;" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'"/> -->
                  <i class="material-icons info-icon" @click="e => { e.preventDefault(); }">info</i>
                </span>
              </el-popover>
            </el-checkbox>
          </div>
          <div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[1]">
          <include-consult-complete :data="processorData.steps[1]" />
        </element-processor-step>

      </element-processor>
    </div>
  </div>
</template>
<script>

import moment from 'moment'

export default {
  data(){
    return {
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      moment: moment,
      processorData: {
        title: "전화 상담 예약",
        steps: [
          {
            title: "전화상담",
            formData: {
              insureName: {
                label: "보험종목",
                value: "자동차보험",
                error: "",
                item: [
                  { value: "자동차보험", label: "자동차보험" },
                  { value: "운전자보험", label: "운전자보험" },
                  { value: "실손의료보험", label: "실손의료보험" },
                  { value: "암/2대질병 보험", label: "암/2대질병 보험" },
                  { value: "어린이보험", label: "어린이보험" },
                  { value: "태아보험", label: "태아보험" },
                  { value: "정기보험", label: "정기보험" },
                  { value: "종신보험", label: "종신보험" },
                  { value: "화재보험", label: "화재보험" },
                  { value: "연금보험", label: "연금보험" },
                  { value: "치아보험", label: "치아보험" },
                  { value: "치매보험", label: "치매보험" },
                  { value: "펫보험", label: "펫보험" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              name: {
                label: "이름",
                value: "",
                error: "",
                placeholder: "이름 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              phone: {
                label: "휴대폰번호",
                value: "",
                error: "",
                placeholder: "- 없이 입력 (예:01012345678)",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultDate: {
                label: "상담일시",
                value: new Date(),
                placehodler: "날짜",
                error: "",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              }
            }
          },
          {
            title: "전화상담 예약이 완료되었습니다.",
            label: "예약하신 상담일시에 상담원이 친절하게 안내해 드리겠습니다."
          }
        ], // steps,
        reservation_inflow: '',
      },
      checkmyinsure: false,
      reservation_inflow_referer_source: '',
    }
  },
  watch: {
    'processorData.steps.0.formData.insureName.value' () {
      if(this.processorData.steps[0].formData.insureName.value != this.$route.query.tab)
        this.$router.replace({ query: { tab : this.processorData.steps[0].formData.insureName.value, procstep: this.$route.query.procstep }})
    }
  },
  mounted(){
  },
  created() {
    if(this.$route.query.tab) this.processorData.steps[0].formData.insureName.value = this.$route.query.tab
    if (this.$route.query.name) {
      this.processorData.steps[0].formData.name.value = this.$route.query.name;
    }

    if (this.$route.query.phoneNumber) {
      this.processorData.steps[0].formData.phone.value = this.$route.query.phoneNumber;
    }

    if (this.$route.query.consultRemark) {
      this.processorData.steps[0].formData.consultRemark.value = this.$route.query.consultRemark;
    }

    if (this.$route.query.isDateTime) {
      const { date, time } = this.$getDefaultConsultTime();
      this.processorData.steps[0].formData.consultDate.value = date;
      this.processorData.steps[0].formData.consultTime.value = time;
    }

    if (this.$route.query.reservationInflow) {
      this.reservation_inflow = this.$route.query.reservationInflow;
    }

    if (this.$route.query.refin) {
      this.reservation_inflow_referer_source = this.$route.query.refin;
    }
  },
  methods: {
    submit( finalData ) {
        fetch('https://api64.ipify.org?format=json')
        .then(x => x.json())
        .then(({ ip }) => {
            finalData.ip = ip;

            if (this.reservation_inflow !== '') {
              finalData.reservation_inflow = this.reservation_inflow;
            }

            if (this.checkmyinsure) {
              finalData.checkmyinsure = this.checkmyinsure;
            }

            if (this.reservation_inflow_referer_source !== '') {
              finalData.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
            }
    
            this.$store.dispatch( "reservation/createItems", finalData );
        });
      // finalData.cid = this.$route.query.cid ? this.$route.query.cid: '';
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    checkValue: function( value ) {
      this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].subLabel = value;

      if(this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value) >= 0){

        var index = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value);
        if(value === '미가입' && !this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].requirement){
          this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.splice(index, 1);
        }
      }else{
        if(value != '미가입'){
          var tmp = { label: this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value, value: value };
          this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.push( tmp )
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.checkMyInsurance {
  padding: 2rem;
  padding-top: 0;
  position: relative;

  .el-checkbox {
    font-weight: 600;
    color: #191f28;

    span {
      &.grey-font {
        font-weight: 500;
        color: #8b95a1;
      }
    }

    .info-icon {
      vertical-align: middle;
      margin-left: 2px;
    }

    &.is-checked {
      /deep/ .el-checkbox__label {
        color: unset;
      }
    }
    /deep/ .el-checkbox__input {
      &.is-checked {
        .el-checkbox__inner {
          background-color: #174de5;
          border-color: #174de5;
        }
      }
      .el-checkbox__inner {
        border-radius: 50%;
        width: 18px;
        height: 18px;

        &::after {
          height: 7px;
          left: 5px;
          width: 5px;
          top: 2px;
        }
      }
    }
  }
}
</style>